import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useDropzone } from 'react-dropzone';

import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import HomeIcon from '@mui/icons-material/Home';
import { useMaterialReactTable } from 'material-react-table';
import { 
    MaterialReactTable,

} from 'material-react-table';
import SettingsIcon from '@mui/icons-material/Settings';
import moment from 'moment';
import Chip from '@mui/material/Chip';
import CadastrarOcorrencia from './cadastrarOcorrencia';

import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Drawer, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { useParams } from "react-router-dom";
import GarageIcon from '@mui/icons-material/Garage';
import CarRentalIcon from '@mui/icons-material/CarRental';

import {
    Tooltip
} from '@mui/material';
import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import LocalParkingIcon from '@mui/icons-material/LocalParking';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import Rodape from '../../../../../../components/Rodape';

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';

import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';


import { Box, Card, CardContent } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BuildIcon from "@mui/icons-material/Build";
import WarningIcon from "@mui/icons-material/Warning";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const drawerWidth = 240;

const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'white',
        borderColor: 'blue',
    },
}));



export default function Ocorrencias({ veiculo, ocorrencias }) {

    const [loading, setLoading] = useState(true);








    const handleClickGerenciar = (event, cellValues) => {


        window.location.href = "/gestao/operacional/frota/veiculos/ocorrencias/gerenciar/" + cellValues.row.id_ocorrencia;


    };




    const [atualizarOcorrencia, setAtualizarOcorrencia] = useState(false);
    const [ocorrenciaAtualizar, setOcorrenciaAtualizar] = useState(null);

    const openAtualizarOcorrencia = (ocorrencia) => {
        setOcorrenciaAtualizar(ocorrencia);

        setAtualizarOcorrencia(true);
    }



    const closeAtualizarOcorrencia = () => {
        //setOcorrenciaAtualizar(null);

        setAtualizarOcorrencia(false);
    }









    const columns = useMemo(
        () => [



            {
                accessorKey: 'id_ocorrencia', //normal accessorKey
                header: 'ID',
                size: 60,
            },

            {
                accessorKey: 'tipo_ocorrencia',
                header: 'Tipo Ocorrência',
                size: 150,
                Cell: ({ row }) => {
                    switch (row.original.tipo_ocorrencia) {
                        case 0: return 'Multa';
                        case 10: return 'Manutenção';
                        case 20: return 'Acidente';
                        case 30: return 'Baixa';

                        default: return '';
                    }
                },
            },
            {
                header: 'Valor',
                accessorKey: 'valor',
                size: 100,
                Cell: ({ row }) => {
                    return row.original.valor.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
                },
            },
            {
                header: 'Data',
                size: 150,
                accessorKey: 'data_ocorrencia', //normal accessorKey
                Cell: ({ row }) => {
                    const data = moment(row.original.data_ocorrencia, "YYYY-MM-DD");
                    const dataFormatada = data.format("DD/MM/YYYY");
                    return dataFormatada;
                },
            },
            {
                header: 'Hora',
                size: 100,
                accessorKey: 'hora_ocorrencia',
            },
            {
                header: 'Responsável',
                id: 'responsavel',
                size: 350,
                accessorFn: row => {
                    return {
                        responsavel: row.responsavel,

                    };

                },
                Cell: ({ row }) => {
                    var colaborador = row.original.responsavel;
                    var texto = "Nome: " + colaborador.nome + " " + colaborador.sobrenome + " | " +
                        "CPF: " + colaborador.cpf;
                    return (
                        <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                            {texto}
                        </span>
                    );
                }
            },
            {
                header: 'Especificações',
                size: 350,
                accessorFn: row => row.tipo_ocorrencia === 0 ? row.multas : row.manutencoes,
                Cell: ({ row }) => {
                    const especificacoes = row.original.tipo_ocorrencia === 0
                        ? row.original.multas
                        : row.original.manutencoes;

                    return (
                        <>
                            {especificacoes.map((esp, index) => (
                                <Chip
                                    key={index}
                                    label={esp.nome}
                                    style={{
                                        borderRadius: 15,
                                        backgroundColor: '#e3f2fd',
                                        margin: '4px',
                                    }}
                                />
                            ))}
                        </>
                    );
                }
            },

            {
                accessorKey: 'descricao_ocorrencia',
                header: 'Descrição',
                size: 350,
            },


            {
                header: 'Criador',
                id: 'criado_por',
                size: 600,
                accessorFn: row => {
                    return {
                        criador: row.usuario_criador,
                        data: row.data_hora_criacao,

                    };

                },
                Cell: ({ renderedCellValue }) => {
                    var nome = renderedCellValue.criador.nome_amigavel;
                    const data = moment(renderedCellValue.data, "YYYY-MM-DD HH:mm:ss");
                    const dataFormatada = data.format("DD/MM/YYYY [às] HH:mm");
                    return (
                        <span style={{ fontSize: 14, color: 'black', fontSize: 'bold' }}>
                            adicionado por {nome} em {dataFormatada}
                        </span>
                    );
                }
            },


        ],
        [],
    );

    const table = useMaterialReactTable({
        columns: columns,
        data: ocorrencias,
        enableGlobalFilterModes: true,
        enablePagination: true,
        enableRowActions: true,
        paginationDisplayMode: 'pages',
        getRowId: (row) => row.id_ocorrencia,
        enableTopToolbar: true,
        enableBottomToolbar: true,
        enableColumnFilters: true,
        enableColumnActions: false,
        sortable: true,
        enableSorting: true,
        enableRowSelection: false,
        enableColumnFilterModes: true,
        enableExpandAll: true,
        enableColumnPinning: true,
        enableColumnResizing: true,
        initialState: {
            pagination: { pageSize: 100, pageIndex: 0 },
            showGlobalFilter: true,
            density: 'compact',
        },
        muiPaginationProps: {
            rowsPerPageOptions: [100, 500, 1000],
            variant: 'outlined',
        },
        enableFullScreenToggle: true,
        renderDetailPanel: ({ row }) => (
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-around',
                    left: '30px',
                    maxWidth: '1000px',
                    position: 'sticky',
                    width: '100%',
                }}
            />
        ),
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                <Tooltip title="Gerenciar">
                    <IconButton
                        color="primary"
                        onClick={(e) => openAtualizarOcorrencia(row.original)}
                    >

                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),

    });

    return (
        <>
            <MaterialReactTable
                table={table}
            />

            <Dialog open={atualizarOcorrencia} onClose={closeAtualizarOcorrencia} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px' } }}>
                <DialogContent>
                    <CadastrarOcorrencia
                        flag={1}
                        veiculo={veiculo}
                        closeAtualizarOcorrencia={closeAtualizarOcorrencia}
                        ocorrenciaAtualizar={ocorrenciaAtualizar}
                    />
                </DialogContent>
            </Dialog>


        </>
    );
}



